<template>
  <div class="book" v-if="book.sinopse">
    <div class="container">
      <h1>Capítulos</h1>

      <div class="book__content" v-html="book.sinopse"></div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      book: { type: Object, required: true }
    }
  }
</script>


<style lang="scss" scoped>
  .book {
    padding: 60px 0;

    h1 {
      font-family: 'Poppins';
      font-size: 1.875rem;
      margin-bottom: 1.25rem;
    }

    &__content {
      ::v-deep ul {
        li {
          padding: 16px 20px;
          background: darken(#fff, 10%);
          border-radius: 10px;
          font-family: 'Poppins';
        }

        li:not(:last-child) {
          margin-bottom: 10px;
        }
      }
    }
  }
</style>